import styled from "styled-components";
const fontSize = localStorage.getItem("fontSize");
const language = localStorage.getItem("settingUplanguage");

export const MoveInHeader = styled.header`
  background: #101e8e;
  color: #fff;
  width: 100%;
  // height: 20em;
  padding:${language=="ar"?"1.2rem 5rem 1.2rem 4rem":"1.2rem 0rem 1.2rem 4rem"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 992px) {
    padding:${language=="ar"?"6rem 2rem 1.2rem 1rem":"6rem 2rem 1.2rem 1rem"};
  }
`;
export const MiniNav = styled.nav`
  color: white;
  display: flex;
  margin: auto;
  gap: 8px;
  width: 100%;
`;

export const MoveInContainer = styled.div`
  width: 80%;
  margin: auto;
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
`;

export const MiniCardsContainer = styled.section`
  margin-top: 1rem;
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  height: fit-content;
  position: sticky;
  top: 1rem;
`;

export const MiniCard = styled.button`
  padding: 1rem;
  border: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  color: #101e8e;
  width: 100%;
  height: calc(90%+0.2rem);
`;

export const FeedContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 65%;
`;

export const FeedTitle = styled.div`
  background: #62aa51;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    color: #fff;
    img {
      color: #101e8e;
    }
  }
  button {
    color: white;
    background: #101e8e;
    border: none;
    padding: 0.5rem;
    cursor: pointer;
  }
`;

export const FeedSection = styled.div`
  display: flex;
  width: 100%;
  gap: 1rem;
  justify-content: space-between;
`;

export const FeedCards = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
  gap: 0.5rem;
  position: sticky;
  top: 1rem;
`;

export const FeedCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  gap: 1rem;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
  background: #fff;
  span {
    width: 90%;
    font-size: calc(${fontSize} - 0.2rem);
    color: #101e8e;
    display: flex;
    align-items: center;
    gap: 0.3rem;
  }
`;

export const Feed = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 65%;
  gap: 0.5rem;
`;

export const FeedPost = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  gap: 1rem;
  background: #fff;
  color: #101e8e;
`;
